module.exports = __webpack_public_path__ + "img/query.6aa9f933.png";